export const MAX_TEXT_EDIT_LENGTH = 2000;

export const TEXT_EDIT_EXAMPLES = [
  'Entferne den roten Hocker.',
  'Ändere die Farbe des Teppichs zu Beige. Erhalte sein Muster.',
  'Entferne die Gegenstände vom Esstisch. Behalte den Tisch unverändert.',
] as const;
